<template>
    <div
        class="relative overflow-hidden shrink-0 box-border rounded-t-10"
        data-component="AmsListItemPicture"
        :class="{
            'screen-m:rounded-[5px]': !isVertical,
        }"
    >
        <picture>
            <img
                v-if="imageUrlResized"
                class="object-cover object-center w-full h-full transition-transform"
                :src="imageUrlResized"
                :alt="item.title"
            />
            <fallback-image-svg v-else class="object-cover w-full h-full transition-transform" />
        </picture>
        <cs-tag
            v-if="item.recommended"
            :class="{
                'screen-m:hidden': !isVertical,
            }"
            class="absolute bottom-0 ml-8 rounded-b-none"
            :type="Components.CsTag.Type.Recommendation"
        >
            <template #icon> <ms-check-medal /> </template>
            Empfehlung
        </cs-tag>
        <div
            v-if="item.images && item.imageCount"
            class="absolute inline-flex items-center rounded-normal bottom-8 right-8 bg-black/50 text-white pl-4 pr-8"
        >
            <ms-image class="w-[22px] h-[22px] mr-4" />
            <span class="text-text font-bold"> {{ item.imageCount }} Bilder </span>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { PropType } from 'vue'
import { CsTag } from '@sunrise/components'
import { Components } from '@sunrise/types'
import FallbackImageSvg from './fallback_img.svg'
import { useItemResizedImageURL } from '../../composables/useItemResizedImageURL'
import { AmsItem } from '../../services/amsSearch/amsSearch.interface'
import { MsCheckMedal, MsImage } from '@sunrise/icons'

const props = defineProps({
    item: {
        type: Object as PropType<AmsItem>,
        required: true,
    },
    isVertical: {
        type: Boolean,
        default: false,
    },
})

const imageUrlResized = useItemResizedImageURL(props.item)
</script>
